// @mui material components
import Grid from "@mui/material/Grid";
import RefreshIcon from "@mui/icons-material/Refresh";

// formik components
import { FieldArray, useFormikContext } from "formik";
import { useFormAnalyticsContext } from "contexts/contextFormAnalytics";

// Material Dashboard 2 PRO React TS components
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import FormField from "components/FormField";

function CumulativesIncForm({ formData }: any): JSX.Element {
  const { formField, values, errors, touched } = formData;
  const { cumulativesInc } = formField;

  const { countryDefaults } = useFormAnalyticsContext();
  const { setFieldValue } = useFormikContext<any>();

  const resetValues = () => {
    if (countryDefaults?.cumulativesInc)
      setFieldValue(formField.cumulativesInc.name, countryDefaults.cumulativesInc);
  };

  return (
    <MDBox borderRadius="lg" borderColor="red" border={1} pr={2} my={1}>
      <Grid container justifyContent={"center"}>
        <Grid item xs={12}>
          <MDTypography variant="h6" sx={{ whiteSpace: "pre-wrap" }}>
            Attained cumulatives for{"\n"}incidence rates (admin):
          </MDTypography>
          <MDButton
            variant="gradient"
            color="dark"
            size="small"
            iconOnly
            onClick={() => resetValues()}
          >
            <RefreshIcon />
          </MDButton>
        </Grid>
        <Grid container xs={6}>
          {Array.from({ length: 14 }, (_, i) => 1910 + i * 10).map((year, index) => (
            <Grid item xs={12} key={"cumulativeIncLabel." + index}>
              <MDTypography variant="caption">{year}</MDTypography>
            </Grid>
          ))}
        </Grid>
        <FieldArray
          name="cumulativesInc"
          render={(_) => (
            <Grid container xs={6}>
              {values.cumulativesInc.map((cumulative: number, index: number) => (
                <FormField
                  key={`cumulativesInc.${index}`}
                  type={cumulativesInc.type}
                  label={cumulativesInc.label}
                  name={`cumulativesInc.${index}`}
                  value={cumulative}
                  error={errors.cumulativesInc && touched.cumulativesInc}
                  precision={3}
                />
              ))}
            </Grid>
          )}
        />
        <Grid item xs={12}>
          <MDTypography
            variant="caption"
            color="error"
            fontWeight="regular"
            sx={{ whiteSpace: "pre-wrap" }}
          >
            {errors.cumulativesInc}
          </MDTypography>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default CumulativesIncForm;
